<template>
    <layout :showuserinfo="false">
        <div class="container-fluid  h-100">
            <div class="page-wrapper-portal">
                <MenuNav />
                <template v-if="$zutil.pwaMobile() == 1">
                    <Menu :auth="auth" :link="'transaksi'" />
                    <div class="row px-3">
                        <div class="row mt3">
                            <h3>Senarai Transaksi</h3>
                        </div>
                        <div class="row px-3 d-flex justify-content-center">
                            <div class="col">
                                <w-dialog v-model="filter.show" title="Carian Terperinci" persistent ref="modalRef">
                                    <div class="row">
                                        <div class="col-12">
                                            <w-select :items="sumber" label="Jenis Pembayaran" v-model="cari.lkp_sumber_id"
                                                @input="carian" class="mb-2"></w-select>
                                            <w-input v-model="cari.no_rujukan" required label="No. Rujukan" @input="carian"
                                                class="mb-2" />
                                            <w-input v-model="cari.keterangan" required label="Nama" @input="carian"
                                                class="mb-2" />
                                            <z-input label="Tarikh" name="tarikh_bayar" v-model="cari.tarikh_bayar"
                                                type="date" @input="carian" class="mb-2" />
                                            <w-input v-model="cari.no_resit" required label="No. Resit" @input="carian"
                                                class="mb-2" />
                                            <w-select :items="cara_terimaan" label="Cara Pembayaran"
                                                v-model="cari.lkp_cara_terimaan_id" @input="carian" class="mb-2"></w-select>
                                        </div>
                                    </div>

                                    <template #actions>
                                        <div class="spacer" />
                                        <button class="btn btn-primary mr1" :loading="loading" :disabled="loading === false"
                                            @click="carian()" bg-color="error">
                                            Cari
                                        </button>
                                        <button class="btn btn-danger" @click="filter.show = false" bg-color="success">
                                            Tutup
                                        </button>
                                    </template>
                                </w-dialog>
                            </div>

                        </div>
                        <div class="col-lg-12">


                            <div class="row h-100 d-flex justify-content-center">

                                <!-- -->
                                <div class="col-12">
                                    <div class="card border shadow" style="height: 550px; overflow: hidden;">
                                        <div class="card-header">
                                            <div class="row d-flex " style="width: 100%;">

                                                <div class="text-left" style="width: 50%;" @click="filter.show = true"><i
                                                        class="mdi mdi-filter font-16 me-2"></i>Carian Terperinci</div>

                                                <div class="text-right" style="width: 50%;">Pilih Semua <w-checkbox
                                                        v-model="pilih" @click="cekPilih"></w-checkbox></div>
                                            </div>

                                        </div><!--end card-header-->
                                        <div class="card-body" style="overflow-y: auto;">
                                            <div class="shopping-cart">
                                                <!-- <div class="float-right">
                                                    <w-button bg-color="success" class="mr3" @click="cetak">
                                                                    <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                                                                </w-button>
                                                </div> -->

                                                <!-- <template v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                                    <div class="col-xs-12 mb-3" >
                                                        <div class="row align-items-center">
                                                                <w-select :items="sumber" label="Jenis Pembayaran" v-model="cari.lkp_sumber_id" @input="carian" class="mb-2"></w-select> 
                                                                <w-input v-model="cari.no_rujukan" required label="No. Rujukan" @input="carian" class="mb-2"/>
                                                                <w-input v-model="cari.keterangan" required label="Nama" @input="carian" class="mb-2"/>
                                                                <z-input 
                                                                    label="Tarikh" 
                                                                    name="tarikh_bayar" 
                                                                    v-model="cari.tarikh_bayar" 
                                                                    type="date" @input="carian" class="mb-2"/>
                                                                <w-input v-model="cari.no_resit" required label="No. Resit" @input="carian" class="mb-2"/>
                                                                <w-select :items="cara_terimaan" label="Cara Pembayaran" v-model="cari.lkp_cara_terimaan_id" @input="carian" class="mb-2"></w-select> 
                                                            
                                                        </div>
                                                    </div> 
                                                </template>
                                                <template v-else>

                                                 <div class="row">
                                                    <div class="col-10">
                                                        <div class="col-lg-12 mb-3" >
                                                            <div class="row align-items-center">
                                                                <div class="col">
                                                                    <w-select :items="sumber" label="Jenis Pembayaran" v-model="cari.lkp_sumber_id" ></w-select> 
                                                                </div> end col

                                                                <div class="col">
                                                                    <w-input v-model="cari.no_rujukan" required label="No. Rujukan"/>
                                                                </div> end col

                                                                <div class="col">
                                                                    <w-input v-model="cari.keterangan" required label="Nama"/>
                                                                </div> end col

                                                                <div class="col">
                                                                    <z-input 
                                                                        label="Tarikh" 
                                                                        name="tarikh_bayar" 
                                                                        v-model="cari.tarikh_bayar" 
                                                                        type="date" />
                                                                </div> end col

                                                                <div class="col">
                                                                    <w-input v-model="cari.no_resit" required label="No. Resit"/>
                                                                </div> end col

                                                                <div class="col">
                                                                    <w-select :items="cara_terimaan" label="Cara Pembayaran" v-model="cari.lkp_cara_terimaan_id" ></w-select> 
                                                                </div> end col
                                                                <div class="col">
                                                                    <w-input v-model="cari.payment_id" required label="payment id" />
                                                                </div> end col

                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-2"> 
                                                        <w-button 
                                                              class="ml1 float-right mr3 mt1" 
                                                              :loading="loading"
                                                              :disabled="loading === false"
                                                              @click="reset()"
                                                              >Reset</w-button>
                                                              &nbsp;&nbsp;

                                                         <w-button 
                                                              class="ml1 float-right mr3 mt1" 
                                                              :loading="loading"
                                                              :disabled="loading === false"
                                                              @click="carian()"
                                                              >Carian</w-button>
                                                    </div>
                                                </div>
                                                </template> -->

                                                <!-- <template v-if="$zutil.pwaMobile() == 1">

                                                    <div class="float-right">
                                                        <button :href="datas.url" target="_blank" class="btn btn-primary mr3 mt4" @click="cetak_senarai">
                                                            <i class="mdi mdi-printer font-16 me-2"></i> Cetak Senarai
                                                        </button>
                                                        <button  class="mr3 mt4 btn btn-warning" @click="cetak">
                                                            <i class="mdi mdi-printer font-16 me-2"></i> Cetak
                                                        </button>
                                                    </div>
                                                </template>
                                                <template v-else>

                                                <div class="float-right">
                                                    <w-button bg-color="success" :href="datas.url" target="_blank" class="mr3 mt4" @click="cetak_senarai">
                                                        <i class="mdi mdi-printer font-16 me-2"></i> Cetak Senarai
                                                    </w-button>
                                                    <w-button bg-color="success" class="mr3 mt4" @click="cetak">
                                                        <i class="mdi mdi-printer font-16 me-2"></i> Cetak
                                                    </w-button>
                                                </div>
                                                </template> -->
                                                <template v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                                    <table class="table mb-0">
                                                        <tbody>

                                                            <tr v-for="dt, index in datas">
                                                                <td>
                                                                    <div class="card border">
                                                                        <div class="card-header bg-dark text-white">
                                                                            <strong>{{ dt.sumber_keterangan }}</strong>
                                                                            <w-checkbox v-model="dt.pilih"
                                                                                class="float-right bg-light border-0" color="error"></w-checkbox>
                                                                        </div>

                                                                        <div class="card-body">
                                                                            {{ dt.no_rujukan }} | {{ dt.keterangan }}<br>
                                                                            <!-- {{$zutil.dateformat(dt.created_at)}} -->
                                                                            <strong>Tarikh</strong><br>
                                                                            {{ dt.tarikh_masa }}<br><br>
                                                                            <strong>No Resit</strong><br>
                                                                            {{ dt.no_resit }}<br>
                                                                            <strong>Cara Pembayaran</strong><br>
                                                                            {{ dt.cara_terimaan_keterangan }}

                                                                        </div>
                                                                        <div class="card-footer bg-dark text-white">
                                                                            <strong>Amaun:
                                                                                RM{{ $zutil.currency(dt.amaun) }}</strong>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <tr v-if="datas.length == 0">

                                                                <td colspan="5">
                                                                    Tiada Rekod.
                                                                </td>

                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </template>
                                                <template v-else>
                                                    <table class="table mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th>Bil</th>
                                                                <th class="border-top-0">Jenis Pembayaran</th>
                                                                <th>No. Rujukan | Nama </th>
                                                                <th>Tarikh </th>
                                                                <th>No. resit</th>
                                                                <th>Cara Pembayaran</th>
                                                                <th>Payment ID</th>
                                                                <!-- <th>Status</th> -->
                                                                <td align="right"><b>Amaun (RM)</b></td>
                                                                <td align="right"><w-checkbox v-model="pilih"
                                                                        @click="cekPilih"></w-checkbox></td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="dt, index in datas">
                                                                <td>{{ (index + 1) }}</td>
                                                                <td>{{ dt.sumber_keterangan }} </td>
                                                                <td>{{ dt.no_rujukan }} | {{ dt.keterangan }}</td>
                                                                <td>
                                                                    <!-- {{$zutil.dateformat(dt.created_at)}} -->
                                                                    {{ dt.tarikh_masa }}
                                                                </td>
                                                                <td>{{ dt.no_resit }}</td>
                                                                <td>{{ dt.cara_terimaan_keterangan }} </td>
                                                                <td>{{ dt.payment_id }} </td>
                                                                <td align="right">{{ $zutil.currency(dt.amaun) }}</td>
                                                                <td align="right">
                                                                    <w-checkbox v-model="dt.pilih"></w-checkbox>


                                                                </td>
                                                            </tr>

                                                            <tr v-if="datas.length == 0">

                                                                <td colspan="5">
                                                                    Tiada Rekod.
                                                                </td>

                                                            </tr>

                                                        </tbody>
                                                    </table>

                                                </template>


                                                <!-- <template v-if="$zutil.pwaMobile() == 1">

                                                    <div class="float-right">
                                                        <button :href="datas.url" target="_blank" class="btn btn-primary mr3 mt4" @click="cetak_senarai">
                                                            <i class="mdi mdi-printer font-16 me-2"></i> Cetak Senarai
                                                        </button>
                                                        <button  class="mr3 mt4 btn btn-warning" @click="cetak">
                                                            <i class="mdi mdi-printer font-16 me-2"></i> Cetak
                                                        </button>
                                                    </div>
                                                </template>
                                                <template v-else>

                                                    <div class="float-right"> 
                                                    <w-button bg-color="success" :href="datas.url" target="_blank" class="mr3 mt4" @click="cetak_senarai">
                                                        <i class="mdi mdi-printer font-16 me-2"></i> Cetak Senarai
                                                    </w-button>
                                                    <w-button bg-color="success" class="mr3 mt4" @click="cetak">
                                                        <i class="mdi mdi-printer font-16 me-2"></i> Cetak
                                                    </w-button>
                                                </div>
                                                </template> -->

                                            </div>

                                        </div>

                                        <div class="card-footer bg-white">
                                            <div class="float-right">
                                                <button :href="datas.url" target="_blank" class="btn btn-primary mr3 mt4"
                                                    @click="cetak_senarai">
                                                    <i class="mdi mdi-printer font-16 me-2"></i> Cetak Senarai
                                                </button>
                                                <button class="mr3 mt4 btn btn-warning" @click="cetak">
                                                    <i class="mdi mdi-printer font-16 me-2"></i> Cetak
                                                </button> 
                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>

                </template>
                <template v-else>
                    <div class="card card-pkn">

                        <Menu :auth="auth" :link="'transaksi'" />

                        <div class="card-body card-scroll mb-5">
                            <div class="row ">
                                <div class="col-lg-12">


                                    <div class="row justify-content-center">

                                        <!-- -->
                                        <div class="col-12">
                                            <div class="card">
                                                <div class="card-header">
                                                    <h4 class="card-title"> <i
                                                            class="mdi dripicons-network-3 font-16 me-2"></i> Senarai
                                                        Transaksi</h4>
                                                </div><!--end card-header-->
                                                <div class="card-body">
                                                    <div class="table-responsive shopping-cart">
                                                        <!-- <div class="float-right">
                                                    <w-button bg-color="success" class="mr3" @click="cetak">
                                                                    <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                                                                </w-button>
                                                </div> -->

                                                        <template v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                                            <div class="col-xs-12 mb-3">
                                                                <div class="row align-items-center">
                                                                    <w-select :items="sumber" label="Jenis Pembayaran"
                                                                        v-model="cari.lkp_sumber_id" @input="carian"
                                                                        class="mb-2"></w-select>
                                                                    <w-input v-model="cari.no_rujukan" required
                                                                        label="No. Rujukan" @input="carian" class="mb-2" />
                                                                    <w-input v-model="cari.keterangan" required label="Nama"
                                                                        @input="carian" class="mb-2" />
                                                                    <z-input label="Tarikh" name="tarikh_bayar"
                                                                        v-model="cari.tarikh_bayar" type="date"
                                                                        @input="carian" class="mb-2" />
                                                                    <w-input v-model="cari.no_resit" required
                                                                        label="No. Resit" @input="carian" class="mb-2" />
                                                                    <w-select :items="cara_terimaan" label="Cara Pembayaran"
                                                                        v-model="cari.lkp_cara_terimaan_id" @input="carian"
                                                                        class="mb-2"></w-select>

                                                                </div>
                                                            </div>
                                                        </template>
                                                        <template v-else>

                                                            <div class="row">
                                                                <div class="col-10">
                                                                    <div class="col-lg-12 mb-3">
                                                                        <div class="row align-items-center">
                                                                            <div class="col">
                                                                                <w-select :items="sumber"
                                                                                    label="Jenis Pembayaran"
                                                                                    v-model="cari.lkp_sumber_id"></w-select>
                                                                            </div><!--end col-->

                                                                            <div class="col">
                                                                                <w-input v-model="cari.no_rujukan" required
                                                                                    label="No. Rujukan" />
                                                                            </div><!--end col-->

                                                                            <div class="col">
                                                                                <w-input v-model="cari.keterangan" required
                                                                                    label="Nama" />
                                                                            </div><!--end col-->

                                                                            <div class="col">
                                                                                <z-input label="Tarikh" name="tarikh_bayar"
                                                                                    v-model="cari.tarikh_bayar"
                                                                                    type="date" />
                                                                            </div><!--end col-->

                                                                            <div class="col">
                                                                                <w-input v-model="cari.no_resit" required
                                                                                    label="No. Resit" />
                                                                            </div><!--end col-->

                                                                            <div class="col">
                                                                                <w-select :items="cara_terimaan"
                                                                                    label="Cara Pembayaran"
                                                                                    v-model="cari.lkp_cara_terimaan_id"></w-select>
                                                                            </div><!--end col-->
                                                                            <div class="col">
                                                                                <w-input v-model="cari.payment_id" required
                                                                                    label="payment id" />
                                                                            </div><!--end col-->


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-2">
                                                                    <w-button class="ml1 float-right mr3 mt1"
                                                                        :loading="loading" :disabled="loading === false"
                                                                        @click="reset()">Reset</w-button>
                                                                    &nbsp;&nbsp;

                                                                    <w-button class="ml1 float-right mr3 mt1"
                                                                        :loading="loading" :disabled="loading === false"
                                                                        @click="carian()">Carian</w-button>
                                                                </div>
                                                            </div>
                                                        </template>

                                                        <template v-if="$zutil.pwaMobile() == 1">

                                                            <div class="float-right">
                                                                <button :href="datas.url" target="_blank"
                                                                    class="btn btn-primary mr3 mt4" @click="cetak_senarai">
                                                                    <i class="mdi mdi-printer font-16 me-2"></i> Cetak
                                                                    Senarai
                                                                </button>
                                                                <button class="mr3 mt4 btn btn-warning" @click="cetak">
                                                                    <i class="mdi mdi-printer font-16 me-2"></i> Cetak
                                                                </button>
                                                            </div>
                                                        </template>
                                                        <template v-else>

                                                            <div class="float-right">
                                                                <w-button bg-color="success" :href="datas.url"
                                                                    target="_blank" class="mr3 mt4" @click="cetak_senarai">
                                                                    <i class="mdi mdi-printer font-16 me-2"></i> Cetak
                                                                    Senarai
                                                                </w-button>
                                                                <w-button bg-color="success" class="mr3 mt4" @click="cetak">
                                                                    <i class="mdi mdi-printer font-16 me-2"></i> Cetak
                                                                </w-button>

                                                                

                                                            </div>
                                                        </template>
                                                        <template v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                                            <table class="table mb-0">
                                                                <tbody>
                                                                    <tr>
                                                                        <td align="right">Pilih Semua <w-checkbox
                                                                                v-model="pilih"
                                                                                @click="cekPilih"></w-checkbox></td>
                                                                    </tr>
                                                                    <tr v-for="dt, index in datas">
                                                                        <td>
                                                                            <div class="card border">
                                                                                <div class="card-header bg-light">
                                                                                    <strong>{{ dt.sumber_keterangan
                                                                                    }}</strong>
                                                                                    <w-checkbox v-model="dt.pilih"
                                                                                        class="float-right"></w-checkbox>
                                                                                </div>

                                                                                <div class="card-body">
                                                                                    {{ dt.no_rujukan }} |
                                                                                    {{ dt.keterangan }}<br>
                                                                                    <!-- {{$zutil.dateformat(dt.created_at)}} -->
                                                                                    <strong>Tarikh</strong><br>
                                                                                    {{ dt.tarikh_masa }}<br><br>
                                                                                    <strong>No Resit</strong><br>
                                                                                    {{ dt.no_resit }}<br>
                                                                                    <strong>Cara Pembayaran</strong><br>
                                                                                    {{ dt.cara_terimaan_keterangan }}

                                                                                </div>
                                                                                <div class="card-footer bg-light">
                                                                                    <strong>Amaun:
                                                                                        RM{{ $zutil.currency(dt.amaun)
                                                                                        }}</strong>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    <tr v-if="datas.length == 0">

                                                                        <td colspan="5">
                                                                            Tiada Rekod.
                                                                        </td>

                                                                    </tr>

                                                                </tbody>
                                                            </table>
                                                        </template>
                                                        <template v-else>
                                                            <table class="table mb-0">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Bil</th>
                                                                        <th class="border-top-0">Jenis Pembayaran</th>
                                                                        <th>No. Rujukan | Nama </th>
                                                                        <th>Tarikh </th>
                                                                        <th>No. resit</th>
                                                                        <th>Cara Pembayaran</th>
                                                                        <th>Payment ID</th>
                                                                        <!-- <th>Status</th> -->
                                                                        <td align="right"><b>Amaun (RM)</b></td>
                                                                        <td align="right"><w-checkbox v-model="pilih"
                                                                                @click="cekPilih"></w-checkbox></td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="dt, index in datas">
                                                                        <td>{{ (index + 1) }}</td>
                                                                        <td>{{ dt.sumber_keterangan }} </td>
                                                                        <td>{{ dt.no_rujukan }} | {{ dt.keterangan }}</td>
                                                                        <td>
                                                                            <!-- {{$zutil.dateformat(dt.created_at)}} -->
                                                                            {{ dt.tarikh_masa }}
                                                                        </td>
                                                                        <td>{{ dt.no_resit }}</td>
                                                                        <td>{{ dt.cara_terimaan_keterangan }} </td>
                                                                        <td>{{ dt.payment_id }} </td>
                                                                        <td align="right">{{ $zutil.currency(dt.amaun) }}
                                                                        </td>
                                                                        <td align="right">
                                                                            <w-checkbox v-model="dt.pilih"></w-checkbox>


                                                                        </td>
                                                                    </tr>

                                                                    <tr v-if="datas.length == 0">

                                                                        <td colspan="5">
                                                                            Tiada Rekod.
                                                                        </td>

                                                                    </tr>

                                                                </tbody>
                                                            </table>

                                                        </template>


                                                        <template v-if="$zutil.pwaMobile() == 1">

                                                            <div class="float-right">
                                                                <button :href="datas.url" target="_blank"
                                                                    class="btn btn-primary mr3 mt4" @click="cetak_senarai">
                                                                    <i class="mdi mdi-printer font-16 me-2"></i> Cetak
                                                                    Senarai
                                                                </button>
                                                                <button class="mr3 mt4 btn btn-warning" @click="cetak">
                                                                    <i class="mdi mdi-printer font-16 me-2"></i> Cetak
                                                                </button>
                                                                
                                                            </div>
                                                        </template>
                                                        <template v-else>

                                                            <div class="float-right">
                                                                <w-button bg-color="success" :href="datas.url"
                                                                    target="_blank" class="mr3 mt4" @click="cetak_senarai">
                                                                    <i class="mdi mdi-printer font-16 me-2"></i> Cetak
                                                                    Senarai
                                                                </w-button>
                                                                <w-button bg-color="success" class="mr3 mt4" @click="cetak">
                                                                    <i class="mdi mdi-printer font-16 me-2"></i> Cetak
                                                                </w-button>
                                                                
                                                            </div>
                                                        </template>

                                                    </div>
                                                    <center><template v-if="callback">
                                                    <a :href="callback" class="mr3 mt4 btn btn-warning">Kembali</a>
                                                </template></center>
                                                </div>

                                            </div>


                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>

        </div>


    </layout>
</template>

<script type="text/javascript">
import Menu from '../Menu.vue'
import MenuNav from '../MenuNav.vue'

export default {
    components: {
        Menu, MenuNav
    },
    setup() {

    },
    props: {
        auth: [Array, Object],
        datas: [Array, Object],
        sumber: [Array, Object],
        cara_terimaan: [Array, Object],
        profil_id: [Array, Object],
        callback: [Array, Object],
    },
    data() {
        return {
            lkp_sumber_id: '',
            lkp_cara_terimaan_id: '',
            no_rujukan: '',
            keterangan: '',
            tarikh_bayar: '',
            no_resit: '',
            resit_id: 0,
            senarai: [],
            total_carian: 0.00,
            total_pilih: 0.00,
            cari: 0,
            pilih: false,
            cari: { lkp_sumber_id: '', lkp_cara_terimaan_id: '', no_rujukan: '', keterangan: '', tarikh_bayar: '', no_resit: '', payment_id: '' },
            filter: {
                show: false,
                fullscreen: false,
                persistent: false,
                persistentNoAnimation: false,
                width: 100,
            },
        }
    },
    methods: {
        carian() {
            this.filter.show = false;
            this.$inertia.visit(window.route('landing.transaksi') + '?lkp_sumber_id=' + this.cari.lkp_sumber_id + '&lkp_cara_terimaan_id=' + this.cari.lkp_cara_terimaan_id + '&no_rujukan=' + this.cari.no_rujukan + '&keterangan=' + this.cari.keterangan + '&tarikh_bayar=' + this.cari.tarikh_bayar + '&no_resit=' + this.cari.no_resit + '&payment_id=' + this.cari.payment_id, { preserveState: true, })
        },
        reset() {
            this.cari = { lkp_sumber_id: '', lkp_cara_terimaan_id: '', no_rujukan: '', keterangan: '', tarikh_bayar: '', no_resit: '', payment_id: '' }
            this.carian()
        },
        cekPilih() {

            for (var i in this.datas) {
                this.datas[i].pilih = this.pilih
            }
        },

        cetak() {
            var id = '';
            for (var i in this.datas) {
                if (this.datas[i].pilih == true) {

                    id = this.datas[i].id + ',' + id

                }
            }
            if (id) {
                window.location.href = route("landing.cetak", id) + '?profil_id=' + this.profil_id;

            } else {
                alert('sila pilih dulu.')
            }
        },

        cetak_senarai() {
            var id = '';
            for (var i in this.datas) {
                if (this.datas[i].pilih == true) {

                    id = this.datas[i].id + ',' + id

                }
            }
            if (id) {
                // window.location.href = route("landing.cetak_senarai",id)+'?profil_id='+this.profil_id;
                window.open(route("landing.cetak_senarai", id) + '?profil_id=' + this.profil_id, '_blank');

            } else {
                alert('sila pilih dulu.')
            }
        },

    },
    mounted() {
        this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.lkp_sumber_id) {
            this.lkp_sumber_id = this.cari.lkp_sumber_id
            this.carian();
        }
        if (this.cari.lkp_cara_terimaan_id) {
            this.lkp_cara_terimaan_id = this.cari.lkp_cara_terimaan_id
            this.carian();
        }
        if (this.cari.resit_id) {
            this.resit_id = 1;
        }
    }
}
</script>
<style type="text/css">
.pkn-carian-landing {
    position: inherit !important;
}
</style>
